/* Gestione iscrizione alle notifiche push (Web Push).
 *
 * Il permesso e l'iscrizione sono PER DISPOSITIVO: ogni telefono/browser si
 * iscrive separatamente. Su iOS funziona solo con la PWA installata sulla Home.
 */
import api from "@/lib/api";

/** Il browser supporta le notifiche push? (installata su iOS) */
export function pushSupportato() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

/** iOS che NON è in modalità PWA installata: le push non sono disponibili */
export function iosNonInstallato() {
  const iOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const standalone =
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  return iOS && !standalone;
}

export function permessoNotifiche() {
  return pushSupportato() ? Notification.permission : "unsupported";
}

/** È già iscritto su QUESTO dispositivo? */
export async function eIscritto() {
  if (!pushSupportato()) return false;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return !!sub;
}

function base64UrlToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

/** Chiede il permesso, si iscrive e registra la subscription sul server. */
export async function attivaNotifiche() {
  if (!pushSupportato()) throw new Error("Le notifiche non sono supportate su questo dispositivo.");
  const permesso = await Notification.requestPermission();
  if (permesso !== "granted") throw new Error("Permesso negato. Puoi attivarlo dalle impostazioni del telefono.");

  const { data } = await api.get("/push/chiave-pubblica");
  if (!data?.public_key) throw new Error("Le notifiche non sono ancora configurate sul server.");

  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: base64UrlToUint8Array(data.public_key),
  });
  await api.post("/push/iscrizione", { subscription: sub });
  return true;
}

/** Annulla l'iscrizione su questo dispositivo. */
export async function disattivaNotifiche() {
  if (!pushSupportato()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.delete("/push/iscrizione", { data: { endpoint: sub.endpoint } }); } catch { /* noop */ }
    await sub.unsubscribe();
  }
}
